import React from 'react';
import unverifiedOrgImage from '../../images/unverified_org.svg';

export default function UnpublishedOrganisationPlaceholder () {
    return (
        <div className="no-data-container">
            <img src={unverifiedOrgImage} className="no-data-img" alt="empty-clipboard" />
            <p className="no-data-header">Your organisation is currently unverified.</p>
            <p className="no-data-copy">Our team is reviewing your submission and will update the status soon.</p>
            <p className="no-data-copy">
                Full access to the dashboard features will be unlocked once your organisation is verified.
            </p>
        </div>
    );
}
